import InternationalPhoneInput from "@base/ui/InternationalPhoneInput";
import { TextField } from "@base/ui/TextField";
import { useTranslation } from "react-i18next";
import type { ApplyFormInstance } from "../model/useApplyForm";

type Props = {
  form: ApplyFormInstance;
};

export const ContactInfoFields = ({ form }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <form.Subscribe
        selector={(state) => ({
          countryNumber: state.values.countryNumber,
          phoneNumber: state.values.phoneNumber,
        })}
      >
        {({ countryNumber, phoneNumber }) => (
          <div>
            <span className="text-label2">
              {t("apply.phone.label")} <span className="text-[14px] text-red-500 font-medium leading-none">*</span>
            </span>
            <InternationalPhoneInput
              countryNumber={countryNumber}
              phoneNumber={phoneNumber}
              onChangeCountryNumber={(num) => form.setFieldValue("countryNumber", num)}
              onChangePhoneNumber={(phone) => form.setFieldValue("phoneNumber", phone)}
            />
          </div>
        )}
      </form.Subscribe>

      <form.Field name="email">
        {(field) => {
          const hasError = field.state.meta.isTouched && field.state.meta.errors.length > 0;
          return (
            <TextField required invalid={hasError} disabled>
              <TextField.Label>{t("apply.email.label")}</TextField.Label>
              <TextField.Input value={field.state.value} disabled />
            </TextField>
          );
        }}
      </form.Field>
    </>
  );
};
